<template lang="pug">
.nodeTypeList
  template(v-for="nodeType in sortedNodeTypes")
    node-type-list-item.nodeTypeList__item(
      :node-type="nodeType"
      :departurable="$questsService.getDeparturable(nodeType, relatedNodeTypes)"
      :isNormalQuest="isNormalQuest"
      @departure="nodeType => $emit('departure', nodeType)"
      @click-info="nodeType => $emit('click-info', nodeType)"
    )
</template>

<script>
const NodeTypeListItem = () => import('@/components/molecules/NodeTypeListItem')

export default {
  components: { NodeTypeListItem },
  props: {
    nodeTypes: { type: Array, default: () => [], required: true },
    relatedNodeTypes: { type: Array, default: () => [] },
    isNormalQuest: { type: Boolean, default: () => true },
  },
  computed: {
    sortedNodeTypes() {
      const nodeTypes = this.$util.clone(this.nodeTypes)

      nodeTypes.sort((p, c) => {
        const prev = this.$questsService.getDeparturable(p, this.relatedNodeTypes)
        const current = this.$questsService.getDeparturable(c, this.relatedNodeTypes)
        if (!prev && current) return 1
        if (prev && !current) return -1
        return 0
      })
      return nodeTypes
    },
  },
}
</script>

<style lang="scss" scoped>
.nodeTypeList {
  display: grid;
  grid-gap: 1rem;

  @media (min-width: $breakpoint) {
    grid-gap: 2rem;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
